define('charts/polar-sustained',["require", "exports", "../tracks/track-enabled", "../util/convert", "./polar"], function (require, exports, trackEnabled, convert_1, polar_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.init = void 0;
    function init() {
        trackEnabled.trackEnabled.subscribe(function (track) {
            // Note: it's important that PubSubs are processed in-order
            // to ensure sustained speeds are ready before the chart layer.
            track.processSustained();
        });
        return new polar_1.PolarChart({
            fx: function (d) { return convert_1.default.speed.localValue(d.sustained_x); },
            fy: function (d) { return convert_1.default.speed.localValue(-d.sustained_y); },
            inner: function () { return ({
                x: { min: 0, max: 10 },
                y: { min: -10, max: 0 }
            }); },
            outer: function () { return ({
                x: {
                    min: 0,
                    max: 100 * convert_1.default.speed.units /* max 220mph horizontal */
                },
                y: {
                    min: -111 * convert_1.default.speed.units /* max 250mph down */,
                    max: 50 * convert_1.default.speed.units /* max 90mph up */
                }
            }); }
        });
    }
    exports.init = init;
});
//# sourceMappingURL=/assets/javascripts/charts/polar-sustained.js.map;
